import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { SegnalazioniService } from './segnalazioni.service';

@Injectable({
  providedIn: 'root'
})
export class SegnalazioniDataSource implements DataSource<ModelEventiCalamitosi.SegnalazioneDto> {

  private segnalazioneSubject = new BehaviorSubject<ModelEventiCalamitosi.SegnalazioneDto[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  isLoading: boolean = false;
  errorMessage: string = null;

  public countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private segnalazioniService: SegnalazioniService) {
  }

  loadListaSegnalazioni(
    ipa: string,
    controlList: ModelEventiCalamitosi.SegnalazioneDto[],
    filter: ModelEventiCalamitosi.SegnalazioniSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    ente: number,
    selezionaTutti?: string) {

    this.loadingSubject.next(true);

    this.segnalazioniService.getList(pageIndex, pageSize, sortDirection, ente, filter).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe(result => {

      let listSegnalazioni: ModelEventiCalamitosi.SegnalazioneDto[] = result['content'];
      if (selezionaTutti) {
        if (selezionaTutti === 'S') {
          listSegnalazioni.forEach(element => {
            if (element.selezionato === 'N' || !element.selezionato) element.selezionatoFE = true;
            element.selezionato = 'S';
          });
          listSegnalazioni.forEach(element => {
            let present: boolean = false;
            controlList.forEach(controlEle => {
              if (controlEle.codiceSegnalazione === element.codiceSegnalazione) present = true;
            });
            if (present) element.selezionato = 'N';
          });
        } else if (selezionaTutti === 'N') {
          listSegnalazioni.forEach(element => {
            if (element.selezionato === 'N') {
              element.selezionatoFE = true;
            } else element.selezionato = 'N';
          });
          listSegnalazioni.forEach(element => {
            let present: boolean = false;
            controlList.forEach(controlEle => {
              if (controlEle.codiceSegnalazione === element.codiceSegnalazione) present = true;
            });
            if (present) element.selezionato = 'S';
          });
        }
      }
      else {
        listSegnalazioni.forEach(element => {
          controlList.forEach(controlEle => {
            if (controlEle.codiceSegnalazione === element.codiceSegnalazione && controlEle.selezionato !== element.selezionato) {
              element.selezionato = controlEle.selezionato;
              element.selezionatoFE = true;
            }
          });
        });
      }

      this.segnalazioneSubject.next(result['content']);
      this.countSubject.next(result['totalElements']);
    });
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.SegnalazioneDto[]> {
    return this.segnalazioneSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.segnalazioneSubject.complete();
    this.loadingSubject.complete();
  }

}
